


import { useContext } from "react"; 
import CurrUserContext from "./CurrUserContext";  
import { AccountInfoModel } from "../generated/api";  

export function useCurrUserUtility() {
  const { setUserData, getCurrUserData,getCurrUsrToken, isAuthorized } = useContext(CurrUserContext);
    
  const setUser = (usr: AccountInfoModel|undefined) => {
    setUserData(usr);
  };

  const getCurrUser = (): AccountInfoModel|undefined => {
    return getCurrUserData();
  };

  const getCurrUserToken = (): string | undefined =>{ 
    return getCurrUsrToken();
  }

  const isAuth = () :boolean => {
       return isAuthorized();
  };
 

  return {  setUser, getCurrUser, getCurrUserToken, isAuth };
}